export default __webpack_public_path__ + "src/appV2/redesign/WorkerShifts/assets/images/empty-state-card-bg-new.png";